import {
  isRentersQuote,
  isAutoQuoteCheckout,
  isAutoQuoteVars,
} from '../services/typeGuards';

import type { AppStoreState } from '.';

export const getAutoQuote = (state: AppStoreState) =>
  isRentersQuote(state.quote) ? null : state.quote;

export const getAutoQuoteCheckout = (state: AppStoreState) =>
  isAutoQuoteCheckout(state.quoteCheckout) ? state.quoteCheckout : null;

export const getAutoQuoteVars = (state: AppStoreState) =>
  isAutoQuoteVars(state.quoteVars) ? state.quoteVars : null;

export const getEnrollmentApplication = (state: AppStoreState) =>
  state.enrollmentApplication;

export const getFeatureFlags = (state: AppStoreState) => state.featureFlags;

export const getIsCCPABannerOpen = (state: AppStoreState) =>
  state.isCCPABannerOpen;

export const getIsLoggedIn = (state: AppStoreState) => !!state.oktaAccessToken;

export const getOktaAccessToken = (state: AppStoreState) =>
  state.oktaAccessToken;

export const getOktaIdToken = (state: AppStoreState) => state.oktaIdToken;

export const getPlans = (store: AppStoreState) => store.plans;

export const getPolicies = (store: AppStoreState) => store.policies;

export const getQuoteData = (state: AppStoreState) => state.quoteData;

export const getRentersQuote = (state: AppStoreState) =>
  isRentersQuote(state.quote) ? state.quote : undefined;

export const getUrlParams = (store: AppStoreState) => store.urlParams;

export const getUser = (store: AppStoreState) => store.user;
